import LegalDocPage from '@/components/LegalDocPage';

const PrivacyPolicy = () => <LegalDocPage documentType="privacy" title="Privacy Policy" />;

export default PrivacyPolicy;
